import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { API_URL } from '../../../constants/api';
import { apiBatchRequest, apiPostNoLoader } from '../../../utils/api_service';
import { toastType, ShowToast } from '../../../utils/toast-service';
import PageHeader from '../PageHeader';
import GridTable from '../Table/Table';
import { UpdateColumnWithConfiguration } from '../../../utils/helper';
import { PendingNotificationColumn } from '../../../constants/MockData';
import { IconButton, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import MarkunreadIcon from '@material-ui/icons/Markunread';
import DraftsIcon from '@material-ui/icons/Drafts';
import ConfirmDialog from '../Dailogbox/confirmDailog';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import commonLabels from '../../../constants/messageConstants';

function ShowAllPendingNotifications () {
  const [pendingNotifications, setPendingNotifications] = useState([]);
  const [read, setRead] = useState({ readNotification: false });
  const [isPopupOpen, setIsPopUpOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [isDelete, setIsDelete] = useState(false);
  const [updateData, setUpdateData] = useState({ notificationMasterId: 0 });
  const [action, setAction] = useState('');
  const [isDeleteAll, setisDeleteAll] = useState(false);
  const [sendRead, setSendRead] = useState(false);

  const handleUnRead = (row, read) => {
    setUpdateData({
      ...updateData,
      notificationMasterId: row.notificationMasterId
    });
    setisDeleteAll(false);
    setIsDelete(false);
    handleReadValue();
    setSendRead(true);

    sendReadNotification(row.notificationMasterId, read);
    getNotificationMaster();
  };

  const sendReadNotification = (id, read) => {
    const params = {
      notificationId: id,
      isDeleteAll: false,
      action: read
    };
    apiPostNoLoader({
      url: API_URL.Dashboard.UpdateNotificationAction,
      params: {},
      postBody: params
    }).then(({ data }) => {
      if (data.success) {
        if (read.toLowerCase() === 'delete') {
          ShowToast('Notification deleted successfully', toastType.SUCCESS, 2000, 500);
        } else if (read.toLowerCase() === 'read'.toLowerCase()) {
          ShowToast('Notification marked as read ', toastType.SUCCESS, 2000, 500);
        } else if (read.toLowerCase() === 'unRead'.toLowerCase()) {
          ShowToast('Notification marked as unread ', toastType.SUCCESS, 2000, 500);
        }
        getNotificationMaster();
        setUpdateData({ notificationMasterId: 0 });
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
      }
    });
  };

  const handleReadValue = () => {
    if (action === '' || action === 'UnRead') {
      setAction('Read');
    } else {
      setAction('UnRead');
    }
  };
  const deleteRecord = (row) => {
    // console.log(row);
    setIsPopUpOpen(true);
    setConfirmationMessage('Are you sure you want to delete?');
    setIsDelete(true);
    setUpdateData({
      ...updateData,
      notificationMasterId: row.notificationMasterId
    });
    setAction('delete');
    setisDeleteAll(false);
  };

  const deleteNotification = () => {
    const notificationId = updateData.notificationMasterId;
    const params = {
      notificationId,
      isDeleteAll,
      action
    };
    apiPostNoLoader({
      url: API_URL.Dashboard.UpdateNotificationAction,
      params: {},
      postBody: params
    }).then(({ data }) => {
      if (data.success) {
        if (action === 'delete') {
          ShowToast('Notification deleted successfully', toastType.SUCCESS, 2000, 500);
        } else if (action.toLowerCase() === 'read') {
          ShowToast('Notification marked as read ', toastType.SUCCESS, 2000, 500);
        } else if (action.toLowerCase() === 'unread') {
          ShowToast('Notification marked as unread ', toastType.SUCCESS, 2000, 500);
        }
        getNotificationMaster();
        setUpdateData({ notificationMasterId: 0 });
        setRead('');
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
      }
    });
  };

  const onPopupClickHandle = (value) => {
    if (value) {
      if (isDelete) {
        // console.log(isDelete);
        deleteNotification();
        setIsPopUpOpen(false);
      }
    } else {
      setIsPopUpOpen(false);
    }
  };

  useEffect(() => {
    getNotificationMaster();
  }, []);

  const getNotificationMaster = () => {
    let _asyncRequest = apiBatchRequest([
      {
        url: API_URL.Dashboard.GetPendingNotifications,
        key: 'pendingNotifications'
      }
    ])
      .then(
        ({
          pendingNotifications
        }) => {
          _asyncRequest = null;
          if (pendingNotifications.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          setPendingNotifications(pendingNotifications.data);
        }
      )
      .catch(() => {
        _asyncRequest = null;
      });
  };

  const renderActionColumn = (row) => {
    return (
            <>
                <Tooltip title={row.isRead ? 'Mark as unread' : 'Mark as read'}>
                    <IconButton
                        className=""
                        variant="contained"
                        size="small"
                        component="label"
                    >
                        {row.isRead && <DraftsIcon onClick={() => handleUnRead(row, 'Unread')} />}
                        {!row.isRead && <MarkunreadIcon onClick={() => handleUnRead(row, 'Read')} />}
                    </IconButton>
                </Tooltip>
                <Tooltip title="Delete Notification">
                    <IconButton
                        className=""
                        variant="contained"
                        size="small"
                        component="label"
                        onClick={() => deleteRecord(row)}
                    >
                        <DeleteIcon style={{ cursor: 'pointer', color: 'red' }} />
                    </IconButton>
                </Tooltip>
            </>
    );
  };

  return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <PageHeader
                        key={'Pending_Notifications_List'}
                        title={'Notifications List'}
                        actionsConfig={[
                          {
                            icon: (
                                    <NavLink
                                        to={{
                                          pathname: '/Dashboard'
                                          //  navProps: {
                                          //    selectedRow: value
                                          //  }
                                        }}
                                        style={{ color: '#FFF', fontSize: 'small' }}>
                                        <ArrowBackIcon
                                            size="small"
                                            className="back-button no-print"
                                        />
                                    </NavLink>
                            ),
                            // onClick: this.goBack,
                            title: 'Back to Dashboard'
                          }
                        ]}
                    >
                        Notification List
                    </PageHeader>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    {pendingNotifications === null
                      ? (
                            <>{'No Pending Notifications'}</>
                        )
                      : (
                            <>
                        {isPopupOpen && (
                          <ConfirmDialog
                              IsOpen={isPopupOpen}
                              Message={confirmationMessage}
                              OnHandelClick={(isValid) => {
                                if (isValid) {
                                  onPopupClickHandle(isValid);
                                } else {
                                  onPopupClickHandle(isValid);
                                }
                              }}
                              AgreeText="Yes"
                              DisAgreeText="No"
                          />
                        )}
                                <GridTable
                                    columns={UpdateColumnWithConfiguration(
                                      PendingNotificationColumn,
                                      []
                                    )}
                                    config={{ showPager: true }}
                                    data={pendingNotifications}
                                    renderActionColumn={renderActionColumn}
                                ></GridTable>
                            </>
                        )}{' '}
                </div>
            </div>
        </>
  );
}

export default ShowAllPendingNotifications;
